import { IIndexable } from '../model/IIndexable';
import { SvgData } from '@bpba/modules-components';
import { RubroData } from '../model/RubroData';

export function iconosSliderMapping(item: IIndexable) {
  const data = SvgData.fromJsonObject(item);
  data.enlace = RubroData.getLink(item?.id);
  data.titulo = capitalizeFirstChar(data.titulo?.toLowerCase());

  return data;
}

const exepciones = ['de', 'la', 'y', 'en', 'del', 'con', 'a'];

function capitalizeFirstChar(str?: string) {
  return str
    ? str
        .split(' ')
        .map((word) => (exepciones.includes(word) ? word : word.charAt(0).toUpperCase() + word.slice(1)))
        .join(' ')
    : '';
}
